import { z } from 'zod';

export const CrearMensajeCompraAgilRequestSchema = z.object({
  mensaje: z.string().min(1, 'El mensaje no puede estar vacío')
});

export const CrearMensajeCompraAgilResponseSchema = z.object({
  fecha_creacion: z.string(),
  mensaje: z.string(),
  compra_agil_id: z.number(),
  usuario_autor: z.string(),
  fecha_actualizacion: z.string().nullable(),
  id: z.string(),
  activo: z.boolean()
});

export type CrearMensajeCompraAgilRequest = z.infer<typeof CrearMensajeCompraAgilRequestSchema>;
export type CrearMensajeCompraAgilResponse = z.infer<typeof CrearMensajeCompraAgilResponseSchema>; 